const locales = {
    driver_performance_dateRange_startDate: 'Start Date',
    driver_performance_dateRange_endDate: 'End Date',
};

export default locales;
